import * as types from '../../actionTypes'

export const setSelectedFile = file => ({
  type: types.ROSTER_FILE_SELECTED,
  file,
})
export const setIsSubmitting = () => ({
  type: types.ROSTER_FILE_SUBMITTING,
})

export const setRostingSuccess = data => ({
  type: types.ROSTER_FILE_SUCCEEDED,
  data,
})

export const setRostingError = (errorMessage, file) => ({
  type: types.ROSTER_FILE_ERROR,
  error: errorMessage,
  file: file,
})



// WEBPACK FOOTER //
// ./src/redux/css-admin/roster/actions.js